import { EventEmitter, Component, ChangeDetectionStrategy, ChangeDetectorRef, Inject, PLATFORM_ID, Input, Output, ViewChild, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import Glide from '@glidejs/glide';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["glideEl"];
const _c1 = ["glideSlidesEl"];
function NgxGlideComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxGlideComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxGlideComponent_ng_container_16_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "button", 14);
} if (rf & 2) {
    const glideBullet_r6 = ctx.$implicit;
    ɵngcc0.ɵɵattribute("data-glide-dir", "=" + glideBullet_r6);
} }
function NgxGlideComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxGlideComponent_ng_container_16_button_1_Template, 1, 1, "button", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.glideBullets);
} }
const _c2 = ["*"];
const defaultSettings = {
    type: 'slider',
    startAt: 0,
    perView: 1,
    focusAt: 0,
    gap: 10,
    autoplay: false,
    hoverpause: true,
    keyboard: true,
    bound: false,
    swipeThreshold: 80,
    dragThreshold: 120,
    perTouch: false,
    touchRatio: 0.5,
    touchAngle: 45,
    animationDuration: 400,
    rewind: true,
    rewindDuration: 800,
    animationTimingFunc: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
    direction: 'ltr',
    peek: 0,
    breakpoints: {},
    classes: {
        direction: {
            ltr: 'glide--ltr',
            rtl: 'glide--rtl',
        },
        slider: 'glide--slider',
        carousel: 'glide--carousel',
        swipeable: 'glide--swipeable',
        dragging: 'glide--dragging',
        cloneSlide: 'glide__slide--clone',
        activeNav: 'glide__bullet--active',
        activeSlide: 'glide__slide--active',
        disabledArrow: 'glide__arrow--disabled',
    },
    throttle: 25,
};

const defaultExtraSettings = {
    showArrows: true,
    showBullets: true,
    arrowLeftLabel: 'left',
    arrowRightLabel: 'right',
    listenToEvents: false,
};

class NgxGlideComponent {
    constructor(changeDetectorRef, platformId) {
        this.changeDetectorRef = changeDetectorRef;
        this.platformId = platformId;
        this.showArrows = defaultExtraSettings.showArrows;
        this.showBullets = defaultExtraSettings.showBullets;
        this.arrowLeftLabel = defaultExtraSettings.arrowLeftLabel;
        this.arrowRightLabel = defaultExtraSettings.arrowRightLabel;
        this.listenToEvents = defaultExtraSettings.listenToEvents;
        this.type = defaultSettings.type;
        this.startAt = defaultSettings.startAt;
        this.perView = defaultSettings.perView;
        this.focusAt = defaultSettings.focusAt;
        this.gap = defaultSettings.gap;
        this.autoplay = defaultSettings.autoplay;
        this.hoverpause = defaultSettings.hoverpause;
        this.keyboard = defaultSettings.keyboard;
        this.bound = defaultSettings.bound;
        this.swipeThreshold = defaultSettings.swipeThreshold;
        this.dragThreshold = defaultSettings.dragThreshold;
        this.perTouch = defaultSettings.perTouch;
        this.touchRatio = defaultSettings.touchRatio;
        this.touchAngle = defaultSettings.touchAngle;
        this.animationDuration = defaultSettings.animationDuration;
        this.rewind = defaultSettings.rewind;
        this.rewindDuration = defaultSettings.rewindDuration;
        this.animationTimingFunc = defaultSettings.animationTimingFunc;
        this.direction = defaultSettings.direction;
        this.peek = defaultSettings.peek;
        this.breakpoints = defaultSettings.breakpoints;
        this.classes = defaultSettings.classes;
        this.throttle = defaultSettings.throttle;
        this.mountedBefore = new EventEmitter();
        this.mountedAfter = new EventEmitter();
        this.updated = new EventEmitter();
        this.played = new EventEmitter();
        this.paused = new EventEmitter();
        this.buildedBefore = new EventEmitter();
        this.buildedAfter = new EventEmitter();
        this.ranBefore = new EventEmitter();
        this.ran = new EventEmitter();
        this.ranAfter = new EventEmitter();
        this.ranOffset = new EventEmitter();
        this.runStarted = new EventEmitter();
        this.runEnded = new EventEmitter();
        this.moved = new EventEmitter();
        this.movedAfter = new EventEmitter();
        this.resized = new EventEmitter();
        this.swipeStarted = new EventEmitter();
        this.swipeMoved = new EventEmitter();
        this.swipeEnded = new EventEmitter();
        this.translateJumped = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (isPlatformBrowser(this.platformId) && changes && this.glide) {
            this.update(this.getGlideUpdateSettings(changes));
        }
    }
    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.initGlideBullets();
            this.glide = new Glide(this.glideEl.nativeElement, this.getGlideInitSettings());
            this.initGlideEvents();
            this.mount();
            this.changeDetectorRef.detectChanges();
        }
    }
    ngOnDestroy() {
        this.destroy();
    }
    getStyleDisplay(condition) {
        return condition ? 'block' : 'none';
    }
    getIndex() {
        if (this.glide) {
            return this.glide.index;
        }
    }
    getSettings() {
        if (this.glide) {
            return this.glide.settings;
        }
    }
    getType() {
        if (this.glide) {
            return this.glide.type;
        }
    }
    isDisabled() {
        if (this.glide) {
            return this.glide.disabled;
        }
    }
    mount() {
        if (this.glide) {
            this.glide.mount();
        }
    }
    update(settings) {
        if (this.glide) {
            this.glide.update(settings);
            this.changeDetectorRef.detectChanges();
        }
    }
    destroy() {
        if (this.glide) {
            this.glide.destroy();
        }
    }
    go(pattern) {
        if (this.glide) {
            this.glide.go(pattern);
        }
    }
    pause() {
        if (this.glide) {
            this.glide.pause();
        }
    }
    play(force) {
        if (this.glide) {
            if (typeof force === 'number') {
                this.glide.play(force);
            }
            else {
                this.glide.play();
            }
        }
    }
    disable() {
        if (this.glide) {
            this.glide.disable();
        }
    }
    enable() {
        if (this.glide) {
            this.glide.enable();
        }
    }
    isType(type) {
        if (this.glide) {
            return this.glide.isType(type);
        }
    }
    initGlideBullets() {
        const glideSlidesNativeElement = this.glideSlidesEl.nativeElement;
        const childrenLength = glideSlidesNativeElement.children.length;
        this.glideBullets = [...new Array(childrenLength).keys()];
        this.changeDetectorRef.detectChanges();
    }
    initGlideEvents() {
        if (!this.glide || !this.listenToEvents) {
            return;
        }
        this.glide.on('mount.before', () => this.mountedBefore.emit());
        this.glide.on('mount.after', () => this.mountedAfter.emit());
        this.glide.on('update', () => this.updated.emit());
        this.glide.on('play', () => this.played.emit());
        this.glide.on('pause', () => this.paused.emit());
        this.glide.on('build.before', () => this.buildedBefore.emit());
        this.glide.on('build.after', () => this.buildedAfter.emit());
        this.glide.on('run.before', (move) => this.ranBefore.emit(move));
        this.glide.on('run', (move) => this.ran.emit(move));
        this.glide.on('run.after', (move) => this.ranAfter.emit(move));
        this.glide.on('run.offset', (move) => this.ranOffset.emit(move));
        this.glide.on('run.start', (move) => this.runStarted.emit(move));
        this.glide.on('run.end', (move) => this.runEnded.emit(move));
        this.glide.on('move', (movement) => this.moved.emit(movement));
        this.glide.on('move.after', (movement) => this.movedAfter.emit(movement));
        this.glide.on('resize', () => this.resized.emit());
        this.glide.on('swipe.start', () => this.swipeStarted.emit());
        this.glide.on('swipe.move', () => this.swipeMoved.emit());
        this.glide.on('swipe.end', () => this.swipeEnded.emit());
        this.glide.on('translate.jump', (movement) => this.translateJumped.emit(movement));
    }
    getGlideUpdateSettings(changes) {
        const settings = {};
        for (const key in changes) {
            if (!changes.hasOwnProperty(key)) {
                continue;
            }
            if (!defaultSettings.hasOwnProperty(key)) {
                continue;
            }
            const change = changes[key];
            if (change.previousValue !== change.currentValue) {
                settings[key] = change.currentValue;
            }
        }
        return settings;
    }
    getGlideInitSettings() {
        return {
            type: this.type,
            startAt: this.startAt,
            perView: this.perView,
            focusAt: this.focusAt,
            gap: this.gap,
            autoplay: this.autoplay,
            hoverpause: this.hoverpause,
            keyboard: this.keyboard,
            bound: this.bound,
            swipeThreshold: this.swipeThreshold,
            dragThreshold: this.dragThreshold,
            perTouch: this.perTouch,
            touchRatio: this.touchRatio,
            touchAngle: this.touchAngle,
            animationDuration: this.animationDuration,
            rewind: this.rewind,
            rewindDuration: this.rewindDuration,
            animationTimingFunc: this.animationTimingFunc,
            direction: this.direction,
            peek: this.peek,
            breakpoints: this.breakpoints,
            classes: this.classes,
            throttle: this.throttle,
        };
    }
}
NgxGlideComponent.ɵfac = function NgxGlideComponent_Factory(t) { return new (t || NgxGlideComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NgxGlideComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxGlideComponent, selectors: [["ngx-glide"]], viewQuery: function NgxGlideComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.glideEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.glideSlidesEl = _t.first);
    } }, inputs: { showArrows: "showArrows", showBullets: "showBullets", arrowLeftLabel: "arrowLeftLabel", arrowRightLabel: "arrowRightLabel", listenToEvents: "listenToEvents", type: "type", startAt: "startAt", perView: "perView", focusAt: "focusAt", gap: "gap", autoplay: "autoplay", hoverpause: "hoverpause", keyboard: "keyboard", bound: "bound", swipeThreshold: "swipeThreshold", dragThreshold: "dragThreshold", perTouch: "perTouch", touchRatio: "touchRatio", touchAngle: "touchAngle", animationDuration: "animationDuration", rewind: "rewind", rewindDuration: "rewindDuration", animationTimingFunc: "animationTimingFunc", direction: "direction", peek: "peek", breakpoints: "breakpoints", classes: "classes", throttle: "throttle", arrowLeftTemplate: "arrowLeftTemplate", arrowRightTemplate: "arrowRightTemplate" }, outputs: { mountedBefore: "mountedBefore", mountedAfter: "mountedAfter", updated: "updated", played: "played", paused: "paused", buildedBefore: "buildedBefore", buildedAfter: "buildedAfter", ranBefore: "ranBefore", ran: "ran", ranAfter: "ranAfter", ranOffset: "ranOffset", runStarted: "runStarted", runEnded: "runEnded", moved: "moved", movedAfter: "movedAfter", resized: "resized", swipeStarted: "swipeStarted", swipeMoved: "swipeMoved", swipeEnded: "swipeEnded", translateJumped: "translateJumped" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 17, vars: 17, consts: [[1, "glide"], ["glideEl", ""], ["data-glide-el", "track", 1, "glide__track"], [1, "glide__slides"], ["glideSlidesEl", ""], ["data-glide-el", "controls", 1, "glide__arrows"], ["data-glide-dir", "<", 1, "glide__arrow", "glide__arrow--left"], ["data-glide-dir", ">", 1, "glide__arrow", "glide__arrow--right"], ["data-glide-dir", "<"], [4, "ngTemplateOutlet"], ["data-glide-dir", ">"], ["data-glide-el", "controls[nav]", 1, "glide__bullets"], [4, "ngIf"], ["class", "glide__bullet", 4, "ngFor", "ngForOf"], [1, "glide__bullet"]], template: function NgxGlideComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3, 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "button", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵtemplate(12, NgxGlideComponent_ng_container_12_Template, 1, 0, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵtemplate(14, NgxGlideComponent_ng_container_14_Template, 1, 0, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵtemplate(16, NgxGlideComponent_ng_container_16_Template, 2, 1, "ng-container", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵstyleProp("display", ctx.showArrows ? "block" : "none");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.getStyleDisplay(!ctx.arrowLeftTemplate));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.arrowLeftLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.getStyleDisplay(!ctx.arrowRightTemplate));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.arrowRightLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.getStyleDisplay(!!ctx.arrowLeftTemplate));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.arrowLeftTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.getStyleDisplay(!!ctx.arrowRightTemplate));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.arrowRightTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.showBullets ? "block" : "none");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.glideBullets);
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2, changeDetection: 0 });
NgxGlideComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
NgxGlideComponent.propDecorators = {
    showArrows: [{ type: Input }],
    showBullets: [{ type: Input }],
    arrowLeftLabel: [{ type: Input }],
    arrowLeftTemplate: [{ type: Input }],
    arrowRightLabel: [{ type: Input }],
    arrowRightTemplate: [{ type: Input }],
    listenToEvents: [{ type: Input }],
    type: [{ type: Input }],
    startAt: [{ type: Input }],
    perView: [{ type: Input }],
    focusAt: [{ type: Input }],
    gap: [{ type: Input }],
    autoplay: [{ type: Input }],
    hoverpause: [{ type: Input }],
    keyboard: [{ type: Input }],
    bound: [{ type: Input }],
    swipeThreshold: [{ type: Input }],
    dragThreshold: [{ type: Input }],
    perTouch: [{ type: Input }],
    touchRatio: [{ type: Input }],
    touchAngle: [{ type: Input }],
    animationDuration: [{ type: Input }],
    rewind: [{ type: Input }],
    rewindDuration: [{ type: Input }],
    animationTimingFunc: [{ type: Input }],
    direction: [{ type: Input }],
    peek: [{ type: Input }],
    breakpoints: [{ type: Input }],
    classes: [{ type: Input }],
    throttle: [{ type: Input }],
    mountedBefore: [{ type: Output }],
    mountedAfter: [{ type: Output }],
    updated: [{ type: Output }],
    played: [{ type: Output }],
    paused: [{ type: Output }],
    buildedBefore: [{ type: Output }],
    buildedAfter: [{ type: Output }],
    ranBefore: [{ type: Output }],
    ran: [{ type: Output }],
    ranAfter: [{ type: Output }],
    ranOffset: [{ type: Output }],
    runStarted: [{ type: Output }],
    runEnded: [{ type: Output }],
    moved: [{ type: Output }],
    movedAfter: [{ type: Output }],
    resized: [{ type: Output }],
    swipeStarted: [{ type: Output }],
    swipeMoved: [{ type: Output }],
    swipeEnded: [{ type: Output }],
    translateJumped: [{ type: Output }],
    glideEl: [{ type: ViewChild, args: ['glideEl', { static: false },] }],
    glideSlidesEl: [{ type: ViewChild, args: ['glideSlidesEl', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxGlideComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-glide',
                template: "<div class=\"glide\" #glideEl>\n  <div class=\"glide__track\" data-glide-el=\"track\">\n    <div class=\"glide__slides\" #glideSlidesEl>\n      <ng-content></ng-content>\n    </div>\n  </div>\n  <div class=\"glide__arrows\" data-glide-el=\"controls\" [style.display]=\"showArrows ? 'block' : 'none'\">\n    <button class=\"glide__arrow glide__arrow--left\" data-glide-dir=\"<\" [style.display]=\"getStyleDisplay(!arrowLeftTemplate)\">{{ arrowLeftLabel }}</button>\n    <button class=\"glide__arrow glide__arrow--right\" data-glide-dir=\">\" [style.display]=\"getStyleDisplay(!arrowRightTemplate)\">{{ arrowRightLabel }}</button>\n    <div data-glide-dir=\"<\" [style.display]=\"getStyleDisplay(!!arrowLeftTemplate)\">\n      <ng-container *ngTemplateOutlet=\"arrowLeftTemplate\"></ng-container>\n    </div>\n    <div data-glide-dir=\">\" [style.display]=\"getStyleDisplay(!!arrowRightTemplate)\">\n      <ng-container *ngTemplateOutlet=\"arrowRightTemplate\"></ng-container>\n    </div>\n  </div>\n  <div class=\"glide__bullets\" data-glide-el=\"controls[nav]\" [style.display]=\"showBullets ? 'block' : 'none'\">\n    <ng-container *ngIf=\"glideBullets\">\n      <button class=\"glide__bullet\" *ngFor=\"let glideBullet of glideBullets\" [attr.data-glide-dir]=\"'=' + glideBullet\"></button>\n    </ng-container>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { showArrows: [{
            type: Input
        }], showBullets: [{
            type: Input
        }], arrowLeftLabel: [{
            type: Input
        }], arrowRightLabel: [{
            type: Input
        }], listenToEvents: [{
            type: Input
        }], type: [{
            type: Input
        }], startAt: [{
            type: Input
        }], perView: [{
            type: Input
        }], focusAt: [{
            type: Input
        }], gap: [{
            type: Input
        }], autoplay: [{
            type: Input
        }], hoverpause: [{
            type: Input
        }], keyboard: [{
            type: Input
        }], bound: [{
            type: Input
        }], swipeThreshold: [{
            type: Input
        }], dragThreshold: [{
            type: Input
        }], perTouch: [{
            type: Input
        }], touchRatio: [{
            type: Input
        }], touchAngle: [{
            type: Input
        }], animationDuration: [{
            type: Input
        }], rewind: [{
            type: Input
        }], rewindDuration: [{
            type: Input
        }], animationTimingFunc: [{
            type: Input
        }], direction: [{
            type: Input
        }], peek: [{
            type: Input
        }], breakpoints: [{
            type: Input
        }], classes: [{
            type: Input
        }], throttle: [{
            type: Input
        }], mountedBefore: [{
            type: Output
        }], mountedAfter: [{
            type: Output
        }], updated: [{
            type: Output
        }], played: [{
            type: Output
        }], paused: [{
            type: Output
        }], buildedBefore: [{
            type: Output
        }], buildedAfter: [{
            type: Output
        }], ranBefore: [{
            type: Output
        }], ran: [{
            type: Output
        }], ranAfter: [{
            type: Output
        }], ranOffset: [{
            type: Output
        }], runStarted: [{
            type: Output
        }], runEnded: [{
            type: Output
        }], moved: [{
            type: Output
        }], movedAfter: [{
            type: Output
        }], resized: [{
            type: Output
        }], swipeStarted: [{
            type: Output
        }], swipeMoved: [{
            type: Output
        }], swipeEnded: [{
            type: Output
        }], translateJumped: [{
            type: Output
        }], arrowLeftTemplate: [{
            type: Input
        }], arrowRightTemplate: [{
            type: Input
        }], glideEl: [{
            type: ViewChild,
            args: ['glideEl', { static: false }]
        }], glideSlidesEl: [{
            type: ViewChild,
            args: ['glideSlidesEl', { static: false }]
        }] }); })();

class NgxGlideModule {
}
NgxGlideModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxGlideModule });
NgxGlideModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxGlideModule_Factory(t) { return new (t || NgxGlideModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxGlideModule, { declarations: function () { return [NgxGlideComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxGlideComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxGlideModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxGlideComponent],
                imports: [CommonModule],
                exports: [NgxGlideComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-glide
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxGlideComponent, NgxGlideModule };

//# sourceMappingURL=ngx-glide.js.map